var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSplash = function SvgSplash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 926,
    height: 849,
    viewBox: "0 0 926 849",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    fillRule: "evenodd",
    d: "M354.024-38.387l589.23-64.267c40.789-4.449 80.156 16.47 99.296 52.765C1217.517 281.896 1305 491.798 1305 579.817c0 93.221-98.13 142.342-294.392 147.361C759.973 808.182 603.438 848.684 541 848.684c-102.997 0-257.52-24.763-463.57-74.288-53.698-12.907-86.767-66.902-73.86-120.6 4.65-19.344 14.962-36.86 29.62-50.31 144.54-132.638 230.158-230.937 256.852-294.897 23.562-56.457 17.821-125.95-17.222-208.482-21.585-50.836 2.127-109.544 52.963-131.13 9.003-3.822 18.518-6.303 28.24-7.364z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSplash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/splash.a9c5f5d8.svg";
export { ForwardRef as ReactComponent };